export default __webpack_public_path__ + "static/media/List-grey.4180b799.svg";